import { jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
const ControllerContext = React.createContext(
  void 0
);
const ControllerProvider = React.memo(
  ({ children, wfActions, wfConfig, wfResults }) => {
    const value = useMemo(
      () => ({ wfActions, wfConfig, wfResults }),
      [wfActions, wfConfig, wfResults]
    );
    return /* @__PURE__ */ jsx(ControllerContext.Provider, { value, children });
  }
);
function useController() {
  const context = React.useContext(ControllerContext);
  if (context === void 0) {
    throw new Error("useController must be used within a ControllerProvider");
  }
  return context;
}
export {
  ControllerProvider,
  useController
};
//# sourceMappingURL=controller-context.js.map
